"use client";

import React from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { CasinoPageContext } from "../CasinoPageContext";
import BlogsPageClient from "./BlogsPageClient";
import type { HomepageContentResponse, KeywordsPageResponse } from "../entitites/KeywordsResponse";

interface BlogsPageShellProps {
  website: KeywordsPageResponse | null;
  domain: string;
  blogs: HomepageContentResponse["blogsSection"]["blogs"];
}

const BlogsPageShell: React.FC<BlogsPageShellProps> = ({ website, domain, blogs }) => {
  return (
    <div className="min-h-screen bg-[#050816] text-white">
      <CasinoPageContext.Provider
        value={{ domain, website: website || undefined }}
      >
        <Navbar />
        <BlogsPageClient blogs={blogs} />
        <Footer />
      </CasinoPageContext.Provider>
    </div>
  );
};

export default BlogsPageShell;
